import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/assigned-to-list';
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";

export default class AssignedToField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ASSIGNED_TO;
    }

    get sortHintMessage() {
        return 'Sort by assigned';
    }

    getCsvValue(item) {
        const user = gd.session.users.get(item.assignedToUserId);
        return user ? user.name : '';
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => (i.type === 'project' || !i.item.assignedToUserId) ? '-' : gd.session.users.get(i.item.assignedToUserId).name.toLowerCase()],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, 'gd-field-assigned-to', 'Not assigned');
    }

    // IMPORT

    normalizeCSVValue(value, csvImporter) {
        if (!value) return;

        // this is patch-hack
        // u nih inogda mnogo users - a nuzen tol'ko pervii
        let users = value.trim().split(csvImporter.multiValueDelimiter);

        if (users && users[0]) {
            return mapByUserName(gd.companyId, users[0]);
        } else {
            return;
        }

    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }
}
